import { absolutePath } from "./absolutePath";

export const asyncTasks = {
  index: ({ params = {} } = {}) => absolutePath("async_tasks", params),
};
